import { type PropsWithChildren } from 'react';
import { UserContextWrapper } from '@src/contexts/userContext.tsx';
import { classNames } from '@utils/classNames.ts';
import Menu from '@components/Menu/Menu.tsx';

export function BaseView({ children }: PropsWithChildren) {
  return (
    <UserContextWrapper>
      <div className="flex flex-col-reverse sm:flex-row h-dvh w-full">
        <Menu />
        <div className="flex flex-1 flex-col h-[calc(100%-84px)] sm:h-full w-full sm:w-auto sm:min-w-0 bg-white sm:bg-gray-100">
          <main
            className={classNames(
              'flex-1 h-full w-full',
              'sm:py-6 sm:px-4 mx-auto',
            )}
          >
            {children}
          </main>
        </div>
      </div>
    </UserContextWrapper>
  );
}
